import Link from '@/lib/nav/link';
import { useRouter } from '@/lib/nav/navigation';
import type { MouseEvent, ReactNode } from 'react';

/**
 * Wraps the legal-pages logo link with a "go back to where you came
 * from" behavior. If the previous page was same-origin (e.g., the user
 * opened these pages in a new tab from /signup), router.back() sends
 * them to that page. Otherwise the link falls through and navigates to
 * the landing page at `/`.
 */
export function LegalHomeLink({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  const router = useRouter();

  function handleClick(event: MouseEvent<HTMLAnchorElement>) {
    if (typeof window === 'undefined') return;
    const referrer = document.referrer;
    if (referrer && referrer.startsWith(window.location.origin)) {
      event.preventDefault();
      router.back();
    }
  }

  return (
    <Link href="/" onClick={handleClick} className={className} aria-label="Roam Together home">
      {children}
    </Link>
  );
}
